import Main from './components/Main';
import './components/style.css';

function App() {
	return (
		<>
			<Main />
		</>
	);
}

export default App;
